/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const TODIS_IP_SCHEMA = Yup.object().shape({
    //general section Rules:
    general_road_id: Yup.string("Road ID is alphanumeric").nullable(true),
    startKm: Yup.number()
        .typeError("Invalid data. 'Start km' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'Start km\' must be a number' });
            }
            return true;
        }),
    endKm: Yup.number()
        .typeError("Invalid data. 'End km' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'End km\' must be a number' });
            }
            return true;
        }),
    dateValidTo: Yup.date("Valid from is a Date").required(),
    dateValidFrom: Yup.date("Valid to is a Date").required(),
    dateValidFor: Yup.string("Valid for is a Year"),
    tentTCategory: Yup.string("tent category is alphanumeric").nullable(true),
    routeId: Yup.string("Route ID is alphanumeric").nullable(true),
    nationalRouteId: Yup.string("National Route ID is alphanumeric").nullable(true),
    internatRouteId: Yup.string("International Route ID is alphanumeric").nullable(true),
    startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
    endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
    nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
    addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
    contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
    contactNum: Yup.string()
        .transform((originalValue) => {
            // Si el valor comienza con '+', eliminamos ese símbolo
            return typeof originalValue === 'string' ? originalValue.replace(/^\+/, '') : originalValue;
        })
        .nullable(true)
        .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
            // Permitir números, espacios, y la presencia de '+'
            const isValid = /^[0-9+\s]+$/.test(value) || value === null;

            if (!isValid) {
                throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
            }

            return true;
        }),

    contactEmail: Yup.string("Email")
        .transform((originalValue) => {
            // Realizar transformaciones si es necesario
            return typeof originalValue === 'string' ? originalValue.trim() : originalValue;
        })
        .nullable(true)
        .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
            // Si el valor es null, lo consideramos válido y no aplicamos más validaciones
            if (value === null) {
                return true;
            }

            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

            for (const email of emails) {
                if (!emailRegex.test(email.trim())) {
                    throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
                }
            }

            return true;
        }),

    countryCode: Yup.string("Country Code").nullable(true),
    startKmDirA: Yup.number()
        .typeError("Invalid data. 'Start km (Direction A)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km (Direction A)\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'Start km (Direction A)\' must be a number' });
            }
            return true;
        }),
    startKmDirB: Yup.number()
        .typeError("Invalid data. 'Start km (Direction B)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'Start km (Direction B)\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'Start km (Direction B)\' must be a number' });
            }
            return true;
        }),
    endKmDirA: Yup.number()
        .typeError("Invalid data. 'End km (Direction A)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km (Direction A)\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'End km (Direction A)\' must be a number' });
            }
            return true;
        }),
    endKmDirB: Yup.number()
        .typeError("Invalid data. 'End km (Direction B)' must be a 'number'")
        .nullable(true)
        .test('is-number', 'Invalid data. \'End km (Direction B)\' must be a number', function (value) {
            if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                throw this.createError({ message: 'Invalid data. \'End km (Direction B)\' must be a number' });
            }
            return true;
        }),
    targetTentSec: Yup.number("Targeted TEN-T section(s) (current network layout)").integer("Targeted TEN-T section(s) alphanumeric").nullable(true),
    newTentSec: Yup.number("New TEN-T section(s) (after project's implementation)").integer("New TEN-T section(s) (after project's implementation) alphanumeric").nullable(true),
    immedPartTentNet: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true),

    roadsImpNmDTO: Yup.object().shape({
        targetTentNet: Yup.string('Value should be a text').nullable(true),
        targetTentSec: Yup.string().nullable(true),
        newTentSec: Yup.string().nullable(true),
        newTentSecLength: Yup.number().nullable(true),
        newTentSecLanes: Yup.number().nullable(true),
        newTentSecPavCond: Yup.string().nullable(true),
        newTentSecItsComp: Yup.string().nullable(true),
        newTentSecAltFuels: Yup.string().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsImpPmDescDTO: Yup.object().shape({
        projectName: Yup.string('Value should be a text').nullable(true),
        typeForeseenInterven: Yup.string('Value should be a text').nullable(true),
        length: Yup.number()
            .typeError("Invalid data. 'Length (if linear)(km)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Length (if linear)(km)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Length (if linear)(km)\' must be a number' });
                }
                return true;
            }),
        lanesDirA: Yup.number()
            .typeError("Invalid data. 'No. of Lanes (Direction A)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'No. of Lanes (Direction A)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'No. of Lanes (Direction A)\' must be a number' });
                }
                return true;
            }),
        lanesDirB: Yup.number()
            .typeError("Invalid data. 'No. of Lanes (Direction B)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'No. of Lanes (Direction B)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'No. of Lanes (Direction B)\' must be a number' });
                }
                return true;
            }),
        totalCostCapex: Yup.number()
            .typeError("Invalid data. 'Total Cost (CAPEX)(Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'Total Cost (CAPEX)(Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'Total Cost (CAPEX)(Euro)\' must be a number' });
                }
                return true;
            }),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsImpPmEligiTentDTO: Yup.object().shape({
        motorwayExpress: Yup.boolean().nullable(true),
        otherHighQualiRoads: Yup.boolean().nullable(true),
        rehabReconstru: Yup.boolean().nullable(true),
        alternativeFuels: Yup.boolean().nullable(true),
        itsComp: Yup.boolean().nullable(true),
        tollingInterope: Yup.boolean().nullable(true),
        safetyComp: Yup.boolean().nullable(true),
        tunnelComp: Yup.boolean().nullable(true),
        alternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        alternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        alternativeFuelsHydrogen: Yup.boolean().nullable(true),
        alternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true)
    }),
    roadsImpPmIndicatorsDTO: Yup.object().shape({
        siAnnTraffDemGro: Yup.string('Value should be a text').nullable(true),
        siModalTrans: Yup.string('Value should be a text').nullable(true),
        siAnnTraffAcciRateRed: Yup.string('Value should be a text').nullable(true),
        eiEirr: Yup.string('Value should be a text').nullable(true),
        eiNpv: Yup.number('Value should be number').nullable(true),
        eiSdr: Yup.string('Value should be a text').nullable(true),
        eiProjPlanDesCost: Yup.number('Value should be number').nullable(true),
        eiProjConstCost: Yup.number('Value should be number').nullable(true),
        eiTotalProjCost: Yup.number('Value should be number').nullable(true),
        fiFirr: Yup.string('Value should be a text').nullable(true),
        fiFnpv: Yup.number('Value should be number').nullable(true),
        fiFdr: Yup.string('Value should be a text').nullable(true),
        fiWacc: Yup.string('Value should be a text').nullable(true),
        fiFirtsYearProf: Yup.string('Value should be a text').nullable(true),
        fiDscr: Yup.string('Value should be a text').nullable(true),
        eniCo2Ems: Yup.string('Value should be a text').nullable(true),
        eniNoxEms: Yup.string('Value should be a text').nullable(true),
        eniSo2Ems: Yup.string('Value should be a text').nullable(true),
        eniNmhcEms: Yup.string('Value should be a text').nullable(true),
        eniPpm: Yup.string('Value should be a text').nullable(true),
        eniNoiseLevel: Yup.string('Value should be a text').nullable(true),
        eniCliChangeRes: Yup.string('Value should be a text').nullable(true),
        eniProteNatuaAff: Yup.number('Value should be number').nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsImpPmPiDTO: Yup.object().shape({
        forecastConstPeriod: Yup.number('Value should be number').nullable(true),
        actualConstPeriod: Yup.number('Value should be number').nullable(true),
        forecastCapex: Yup.number('Value should be number').nullable(true),
        actualCapex: Yup.number('Value should be number').nullable(true),
        forecastOpex: Yup.number('Value should be number').nullable(true),
        actualOpex: Yup.number('Value should be number').nullable(true),
        forecastMaintCost: Yup.number('Value should be number').nullable(true),
        actualMaintCost: Yup.number('Value should be number').nullable(true),
        interestDuringConst: Yup.string('Value should be a text').nullable(true),
        ebitda: Yup.string('Value should be a text').nullable(true),
        forecastRevenue: Yup.number('Value should be number').nullable(true),
        actualRevenue: Yup.number('Value should be number').nullable(true),
        forecastPassCars: Yup.string('Value should be a text').nullable(true),
        actualPassCars: Yup.string('Value should be a text').nullable(true),
        forecastBusses: Yup.string('Value should be a text').nullable(true),
        actualBusses: Yup.string('Value should be a text').nullable(true),
        forecastTrucks: Yup.string('Value should be a text').nullable(true),
        actualTrucks: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsImpPmStatusDTO: Yup.object().shape({
        implemented: Yup.string('Value should be a text').nullable(true),
        ongoingProjFs: Yup.string('Value should be a text').nullable(true),
        matureProjFs: Yup.string('Value should be a text').nullable(true),
        projUnderPrep: Yup.string('Value should be a text').nullable(true),
        projStatusDesc: Yup.string('Value should be a text').nullable(true),
        initProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        actualProjCompDate: Yup.date("Valid to is a Date").nullable(true),
        projFundNatBudg: Yup.number()
            .typeError("Invalid data. 'National Budget (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'National Budget (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'National Budget (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundWb: Yup.number()
            .typeError("Invalid data. 'World Bank (Euro)' must be a 'number'")
            .nullable(true)
            .test('is-number', 'Invalid data. \'World Bank (Euro)\' must be a number', function (value) {
                if (isNaN(value) && value !== null && value !== undefined && value !== '') {
                    throw this.createError({ message: 'Invalid data. \'World Bank (Euro)\' must be a number' });
                }
                return true;
            }),
        projFundEbrd: Yup.string('Value should be a text').nullable(true),
        projFundEib: Yup.string('Value should be a text').nullable(true),
        otherIfi: Yup.string('Value should be a text').nullable(true),
        otherIfiSpec: Yup.string('Value should be a text').nullable(true),
        concessions: Yup.string('Value should be a text').nullable(true),
        concessionSpec: Yup.string('Value should be a text').nullable(true),
        euFund: Yup.string('Value should be a text').nullable(true),
        euFundSpec: Yup.string('Value should be a text').nullable(true),
        otherFund: Yup.string('Value should be a text').nullable(true),
        otherFundSpec: Yup.string('Value should be a text').nullable(true),
        projDocTitle: Yup.string('Value should be a text').nullable(true),
        projDocPrepBy: Yup.string('Value should be a text').nullable(true),
        projDocSupervBy: Yup.string('Value should be a text').nullable(true),
        remarks: Yup.string("remarks").nullable(true),
    }),
    roadsImpPmTentcompDTO: Yup.object().shape({
        befProjImpTentComp: Yup.boolean().nullable(true),
        aftProjImpTentComp: Yup.boolean().nullable(true),
        befAltFuelsAvai: Yup.boolean().nullable(true),
        aftAltFuelsAvai: Yup.boolean().nullable(true),
        befItsComp: Yup.boolean().nullable(true),
        aftItsComp: Yup.boolean().nullable(true),
        befTollInterop: Yup.boolean().nullable(true),
        aftTollInterop: Yup.boolean().nullable(true),
        befTunnelComp: Yup.boolean().nullable(true),
        aftTunnelComp: Yup.boolean().nullable(true),
        remarks: Yup.string("remarks").nullable(true),
        befSeparationRoadCarriageways: Yup.boolean().nullable(true),
        aftSeparationRoadCarriageways: Yup.boolean().nullable(true),
        befNoCrossingsAtGrade: Yup.boolean().nullable(true),
        aftNoCrossingsAtGrade: Yup.boolean().nullable(true),
        befRestAreasAvailability: Yup.boolean().nullable(true),
        aftRestAreasAvailability: Yup.boolean().nullable(true),
        befSafeParkingAvailability: Yup.boolean().nullable(true),
        aftSafeParkingAvailability: Yup.boolean().nullable(true),
        befWeighInMotionSystems: Yup.boolean().nullable(true),
        aftWeighInMotionSystems: Yup.boolean().nullable(true),
        befDetectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
        aftDetectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
        befAlternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        aftAlternativeFuelsElectricityLight: Yup.boolean().nullable(true),
        befAlternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        aftAlternativeFuelsElectricityHeavy: Yup.boolean().nullable(true),
        befAlternativeFuelsHydrogen: Yup.boolean().nullable(true),
        aftAlternativeFuelsHydrogen: Yup.boolean().nullable(true),
        befAlternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true),
        aftAlternativeFuelsLiquifiedMethane: Yup.boolean().nullable(true),
    }),
});




const IP_INIT = {
    general_road_id: 0,
    startKm: 0,
    endKm: 0,
    dateValidTo: "",
    dateValidFrom: "",
    dateValidFor: "",
    tentTCategory: "",
    routeId: "",
    nationalRouteId: "",
    internatRouteId: "",
    startNodeName: "",
    endNodeName: "",
    general_status: "",
    nameResp: "",
    addressResp: "",
    contactPer: "",
    contactPos: "",
    contactNum: 0,
    contactEmail: "",
    countryCode: "",
    startKmDirA: 0,
    startKmDirB: 0,
    endKmDirA: 0,
    endKmDirB: 0,
    targetTentSec: 0,
    newTentSec: 0,
    immedPartTentNet: false,
    remarks: "",
    roadsImpNmDTO: {
        targetTentNet: "",
        targetTentSec: "",
        newTentSec: "",
        newTentSecLength: 0,
        newTentSecLanes: 0,
        newTentSecPavCond: "",
        newTentSecItsComp: "",
        newTentSecAltFuels: "",
        remarks: "",
    },
    roadsImpPmDescDTO: {
        projectName: "",
        typeForeseenInterven: "",
        length: 0,
        lanesDirA: 0,
        lanesDirB: 0,
        totalCostCapex: 0,
        remarks: "",
    },
    roadsImpPmEligiTentDTO: {
        motorwayExpress: false,
        otherHighQualiRoads: false,
        rehabReconstru: false,
        alternativeFuels: false,
        itsComp: false,
        tollingInterope: false,
        safetyComp: false,
        tunnelComp: false,
        alternativeFuelsElectricityLight: false,
        alternativeFuelsElectricityHeavy: false,
        alternativeFuelsHydrogen: false,
        alternativeFuelsLiquifiedMethane: false,
        remarks: "",
    },
    roadsImpPmIndicatorsDTO: {
        siAnnTraffDemGro: "",
        siModalTrans: "",
        siAnnTraffAcciRateRed: "",
        eiEirr: "",
        eiNpv: 0,
        eiSdr: "",
        eiProjPlanDesCost: 0,
        eiProjConstCost: 0,
        eiTotalProjCost: 0,
        fiFirr: "",
        fiFnpv: 0,
        fiFdr: "",
        fiWacc: "",
        fiFirtsYearProf: 0,
        fiDscr: "",
        eniCo2Ems: "",
        eniNoxEms: "",
        eniSo2Ems: "",
        eniNmhcEms: "",
        eniPpm: "",
        eniNoiseLevel: "",
        eniCliChangeRes: "",
        eniProteNatuaAff: 0,
        remarks: "",
    },
    roadsImpPmPiDTO: {
        forecastConstPeriod: 0,
        actualConstPeriod: 0,
        forecastCapex: 0,
        actualCapex: 0,
        forecastOpex: 0,
        actualOpex: 0,
        forecastMaintCost: 0,
        actualMaintCost: 0,
        interestDuringConst: "",
        ebitda: "",
        forecastRevenue: 0,
        actualRevenue: 0,
        forecastPassCars: "",
        actualPassCars: "",
        forecastBusses: "",
        actualBusses: "",
        forecastTrucks: "",
        actualTrucks: "",
        remarks: "",
    },
    roadsImpPmStatusDTO: {
        implemented: "",
        ongoingProjFs: "",
        matureProjFs: "",
        projUnderPrep: "",
        projStatusDesc: "",
        initProjCompDate: "",
        actualProjCompDate: "",
        projFundNatBudg: "",
        projFundWb: "",
        projFundEbrd: "",
        projFundEib: "",
        otherIfi: "",
        otherIfiSpec: "",
        concessions: "",
        concessionSpec: "",
        euFund: "",
        euFundSpec: "",
        otherFund: "",
        otherFundSpec: "",
        projDocTitle: "",
        projDocPrepBy: "",
        projDocSupervBy: "",
        remarks: "",
    },
    roadsImpPmTentcompDTO: {
        befProjImpTentComp: false,
        aftProjImpTentComp: false,
        befAltFuelsAvai: false,
        aftAltFuelsAvai: false,
        befItsComp: false,
        aftItsComp: false,
        befTollInterop: false,
        aftTollInterop: false,
        befTunnelComp: false,
        aftTunnelComp: false,
        remarks: "",
        befSeparationRoadCarriageways: false,
        aftSeparationRoadCarriageways: false,
        befNoCrossingsAtGrade: false,
        aftNoCrossingsAtGrade: false,
        befRestAreasAvailability: false,
        aftRestAreasAvailability: false,
        befSafeParkingAvailability: false,
        aftSafeParkingAvailability: false,
        befWeighInMotionSystems: false,
        aftWeighInMotionSystems: false,
        befDetectProvideSafetyTrafficInformation: false,
        aftDetectProvideSafetyTrafficInformation: false,
        befAlternativeFuelsElectricityLight: false,
        aftAlternativeFuelsElectricityLight: false,
        befAlternativeFuelsElectricityHeavy: false,
        aftAlternativeFuelsElectricityHeavy: false,
        befAlternativeFuelsHydrogen: false,
        aftAlternativeFuelsHydrogen: false,
        befAlternativeFuelsLiquifiedMethane: false,
        aftAlternativeFuelsLiquifiedMethane: false
    },
}

export { TODIS_IP_SCHEMA, IP_INIT };